<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Employee Closing Detail
    </div>
    <div class="card-body">

        <div class="row align-items-center user-card">
            <!-- Image -->
            <div class="col-1 text-center">
                <img *ngIf="data.photo" class="userImage" [src]="common.PhotoLink(data.photo)" />

                <div *ngIf="!data.photo" class="initial-image">
                    <div class="image">
                        {{ data[0].FullName.charAt(0) }}
                    </div>
                </div>
            </div>

            <!-- Details -->
            <div class="col-11 userdetail d-flex flex-column justify-content-center">
                <span class="emp-name mb-1">{{ data[0].FullName }}</span>
                <span class="emp-code mb-1">#{{ data[0].EmpCode }}</span>
                <span class="emp-designation">{{ data[0].DesignationName }}</span>
            </div>

        </div>
        <form #leaveupdate="ngForm">
            <div class="mx-1 mt-3 table-responsive">
                <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger"
                    class="table table-bordered customeDatatable">
                    <thead>
                        <tr>
                            <th style="width:20px">#</th>
                            <th style="width:150px">Leave Type</th>
                            <th style="width:80px">Balance</th>
                            <th style="width:100px">Action</th>
                            <th style="width:80px">Count</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let e of data; let i = index">
                            <th class="text-center" style="width:20px">{{i+1}}</th>
                            <td style="width:150px">{{e['LeaveName']}}</td>
                            <td class="text-center" style="width:80px">{{e['Closing']}}</td>
                            <td style="width:100px">
                                <select class="form-select" placeholder="Select Action" name="action{{i}}"
                                    [(ngModel)]="e['action']" required>
                                    <option value="No Action">No Action</option>
                                    <option value="Addition">Addition</option>
                                    <option value="Deduction">Deduction</option>
                                </select>
                            </td>
                            <td style="width:80px">
                                <input (keypress)="onKeyPressNumbersOnly($event)" [(ngModel)]="e['count']"
                                    class="form-control" [disabled]="e['action'] == 'No Action'" name="count{{i}}"
                                    required>
                            </td>
                            <td>
                                <textarea [rows]="1" name="description{{i}}" [(ngModel)]="e['description']"
                                    class="form-control" [disabled]="e['action'] == 'No Action'"
                                    placeholder="Description"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button [disabled]="data.length < 1" (click)="onSubmit(leaveupdate)" class="btn btn-primary btn-sm">
                    Save
                </button>
            </div>
            <div class="col-auto">
                <button (click)="close()" class="btn btn-outline-primary btn-sm">
                    X Close
                </button>
            </div>
        </div>
    </div>
</div>